export default "__VITE_ASSET__CL1lP59X__"